<template lang="pug">
  .container
    .form-group
      label.text-muted Office:
      span.font-weight-bold  {{office.office.name}}
    .form-group
      label.text-muted Message:
      span.font-weight-bold  {{office.message}}
    .form-group.float-right
      b-btn(size="sm" variant="danger" @click="deleteMessage()").mr-1 Yes, Delete
      b-btn(size="sm" @click="cancel()") No, Cancel
</template>
<script>
import makesAjaxRequests from '@/mixins/makesAjaxRequests'
import api from '@/http'
export default {
  name: 'DeleteOfficeMessageForm',

  mixins: [makesAjaxRequests],

  props: {
    office: Object
  },
  methods: {
    deleteMessage () {
      return api.deleteRequest('api/v1/office-message/' + this.office.id).then(resp => {
        this.$emit('close')
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
